import React from 'react';
import DOMPurify from 'dompurify';
import styles from './Contact.module.css';

const StepFour = ({ formData, handleInputChange, errors }) => {
  
  const handleSanitizedInputChange = (value) => {
    const sanitizedValue = DOMPurify.sanitize(value);
    handleInputChange({ target: { name: 'mountingSurface', value: sanitizedValue } });
  };

  const handleKeyDown = (event, value) => {
    if (event.key === 'Enter' || event.key === ' ') {
      handleSanitizedInputChange(value);
    }
  };

  return (
    <div className={styles.step}>
      <h2>Step 4: Mounting Surface</h2>
      <div className={styles.toggle}>
        <button
          type="button"
          className={`${styles.toggleButton} ${formData.mountingSurface === 'Wood' ? styles.active : ''}`}
          onClick={() => handleSanitizedInputChange('Wood')}
          onKeyDown={(event) => handleKeyDown(event, 'Wood')}
          aria-pressed={formData.mountingSurface === 'Wood'}
          tabIndex={0}
        >
          Wood
        </button>
        <button
          type="button"
          className={`${styles.toggleButton} ${formData.mountingSurface === 'Concrete' ? styles.active : ''}`}
          onClick={() => handleSanitizedInputChange('Concrete')}
          onKeyDown={(event) => handleKeyDown(event, 'Concrete')}
          aria-pressed={formData.mountingSurface === 'Concrete'}
          tabIndex={0}
        >
          Concrete
        </button>
      </div>
      {errors.mountingSurface && <p className={styles.error}>{errors.mountingSurface}</p>}
    </div>
  );
};

export default StepFour;